
import { Vue, Component, Prop, PropSync, Watch } from "vue-property-decorator";
import { Action, Getter } from 'vuex-class';
@Component({
  name: "Information",
  components: {},
})
export default class Information extends Vue {
  @Getter("id") private id!: string;
  @Action("policy/getInformationList") private getInformationList: any;
  @Action("policy/setRead") private setRead: any;
  dialogVisible: Boolean = false;
  areaOption: any = [];
  tableData: any = [];
  areaList: any = [];
  departList: any = [];
  keyList: any = [];
  pages = 0;
  total = 0;
  size = 10;
  current = 1;
  created() {
    this.getData();
  }
  setInformationRead({id}: any) {
    const options = {
      id
    }
    this.setRead((options)).then(({code, data, msg}: any) => {
      if(code===0&&data) {
        this.getData();
        return this.$message.success("设置已读成功!")
      }
    })
  }
  getData() {
    const options = {
      current: this.current,
      size: this.size,
    }
    this.getInformationList(options).then((res: any) => {
      const {code, data, msg} = res;
      if(code===0&&data) {
        const {records, total, pages} = data;
        this.total = total;
        this.pages = pages;
        this.tableData = records;
      }
    })
  }
  currentChange(param: number) {
    this.current = param;
    this.getData();
  }
  handleSizeChange(val: any) {
  }
  handleCurrentChange(val: any) {
  }
}
